import base from './base_pt.json';

const extra = {
  'footer_text': `CENTRO DE SERVIÇOS DO IAM
  Endereço: Avenida da Praia Grande, 
  n.º 762-804, 2.º andar, Macau
  CENTRO DE SERVIÇOS DA RAEM
  Endereço: Rua Nova da Areia Preta, n.º 52, Macau
  CENTRO DE SERVIÇOS DA RAEM DAS ILHAS
  Endereço: Rua de Coimbra, n.º225, 3.º andar, Taipa
  Tel: (853) 2822 5000  Fax: (853) 2822 3000`,

}

const output = Object.assign({}, base, extra);
export default output;